let resumeData = {
    "imagebaseurl":"https://github.com/kinziva/HKReactPortfolio",
    "name": "Hanna Keskin",
    "role": "Sofware Developer Engineer in Test and FrontEnd Developer",
    "linkedinId":"Hanna Keskin",
    "email":"hannahkeskin@gmail.com",
    "phone":"5715238018",

    "roleDescription": "I am currently a full-stack developer bootcamp student at George Washington University. My education includes HTML5, CSS3, Javascript, jQuery, Ajax, JSON and Node.js.",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/hanna-keskin-2160b31b3/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/kinziva/",
          "className":"fa fa-github"
        },
        {
          "name":"resume",
          "url":"resume/HannaHKeskin_Resume.pdf",
          "className":"fa fa-file"
        }
      ],
    "aboutme":"I am a Sofware Enginner in Test. My main Langauge is Java,I am testing UI and backend applications. I have both manual and automation experience. I am working on Selenium Cucumber Junit and WebdriverIO frameworks",
    "address":"Herndon, Virginia",
    "website":"https://github.com/kinziva",
    "education":[
      {
        "UniversityName":"Harvard Extension School",
        "specialization":"Web Technology",
      },
      {
        "UniversityName":"Ondokuz Mayis University",
        "specialization":"Computer Education and Information Technology"
      }
    ],
    "work":[
      {
        "CompanyName":"College Board",
        "specialization":"SDET",
      }
    ],
    "skillsDescription":"Your skills here",
    "skills":[
      {
        "skillname":"HTML5"
      },
      {
        "skillname":"CSS"
      },
      {
        "skillname":"Reactjs"
      },
      {
        "skillname":"JAVA"
      },
      {
        "skillname":"Javascript"
      },
      {
        "skillname":"Selenium"
      },
      {
        "skillname":"Cucumber"
      },
      {
        "skillname":"WebdriverIO"
      },
      {
        "skillname":"Photoshop"
      },
      {
        "skillname":"AWS"
      }
    ],
  
    "portfolio":[
      {
        "name":"project1",
        "description":"Wellness Place App",
        "imgurl":"images/portfolio/wa.jpg",
        "github":"https://github.com/kinziva/Project1G4",
        "deployed":"https://kinziva.github.io/Project1G4/"

      },
      {
        "name":"Weather Dashboard",
        "description":"Weather App",
        "imgurl":"images/portfolio/wd.jpg",
        "github":"https://github.com/kinziva/HKweatherDashboard",
        "deployed":"https://kinziva.github.io/HKweatherDashboard/"

      },
      {
        "name":"Fitness Tracker",
        "description":"Fitness Tracker App",  
        "imgurl":"images/portfolio/ft.jpg",
        "github":"https://github.com/kinziva/FitnessTracker",
        "deployed":"https://quiet-fortress-24349.herokuapp.com/"
      },
      {
        "name":"Budget Tracker",
        "description":"Budget Tracker App",  
        "imgurl":"images/portfolio/bt.jpg",
        "github":"https://github.com/kinziva/BudgetTracker",
        "deployed":"https://agile-taiga-28351.herokuapp.com/"
      },
      {
        "name":"Yummy Burger",
        "description":"Burger App",
        "imgurl":"images/portfolio/b.jpg",
        "github":"https://github.com/kinziva/burgerHandleBars",
        "deployed":"https://hidden-gorge-50321.herokuapp.com/"
      },
      {
        "name":"Note Taker App",
        "description":"NoteTakerApp",
        "imgurl":"images/portfolio/nt.jpg",
        "github":"https://github.com/kinziva/noteTakeApp",
        "deployed":"https://secret-mesa-44468.herokuapp.com/"
      },
      {
        "name":"project2",
        "description":"Sell Buy App",
        "imgurl":"images/portfolio/f.jpg",
        "github":"https://github.com/kinziva/Team_Hulk_Group_Project_2",
        "deployed":"https://vast-reaches-08581.herokuapp.com/"
      },
      {
        "name":"Work Day Scheduler",
        "description":"Schedule App",
        "imgurl":"images/portfolio/schedule.jpg",
        "github":"https://github.com/kinziva/HKcalendar",
        "deployed":"https://kinziva.github.io/HKcalendar/"
      }
    ],
    "quotes":[
      {
        "description":"'Everything changes and nothing stands still.'",
        "name":"-Heraclitus"
      },
      {
        "description":"'Quality is never an accident; it is always the result of intelligent effort.'",
        "name":"-John Ruskin"
      },
      {
        "description":"'Just because you've counted all the trees doesn't mean you've seen the forest.'",
        "name":"-Anonymous"
      }
    ]
  }
  
  export default resumeData